<template >
    <div :class="{ '--initial': initial }">
        <div v-if="initial" @click.stop="openImportDialog()" name="import-media-btn" class="initial-import-media-container">
            <v-icon color="#ababab" size="60" class="material-symbols-outlined">add</v-icon>
            <span class="mt-2 text-center">Click here to import media</span>
        </div>
        <v-icon v-else color="#ababab" id="import-media-btn" class="material-icons" @click.stop="openImportDialog()" v-tippy content="Import media">add</v-icon >

<!--        <tippy-->
<!--            v-if="startTipsStep == 1 && projectTree.length == 0"-->
<!--            placement="right"-->
<!--            boundary="window"-->
<!--            theme="&#45;&#45;start"-->
<!--            showOnInit="true"-->
<!--            hideOnClick="false"-->
<!--            interactive-->
<!--            :onHide="function() { return false }"-->
<!--            to="import-media-btn"-->
<!--        >-->
<!--            <span class="step">{{ startTipsStep }} of {{ $startTips.length }}</span>-->
<!--            <span class="title">{{ $startTips[startTipsStep - 1].title }}</span>-->
<!--            <span class="description">{{ $startTips[startTipsStep - 1].description }}</span>-->
<!--        </tippy>-->

        <input type="file" @change="startImportProcess" ref="importMedia" id="import-media" multiple />
    </div>
</template >

<script>

import { mapState } from 'vuex'

export default {
    props: {
        initial: Boolean
    },

    computed: {
        ...mapState('UI', ['startTipsStep']),
        ...mapState('Projects', ['projectTree']),
    },

    methods: {
        async openImportDialog() {
            await this.$store.dispatch('App/setAction', {
                name: 'import-media',
                data: {},
            });

            this.$refs.importMedia.click();
            // this.$store.dispatch('UI/setStartTipsStep', 2);
        },

        async startImportProcess() {
            if (this.$store.state.App.scriptsLoaded) {
                loader.uploadImages();
            }
        }
    }
}
</script >

<style lang="scss" scoped >
input {
    display: none;
}

.--initial {
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
}

.initial-import-media-container {
    display: flex;
    flex-direction: column;
    align-items: center;
    cursor: pointer;
}
</style >
